module.exports = __webpack_public_path__ + "2e6a2f7342724a943ff5a17342cc0971.svg";